import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated [fabric-deprecated] - use mfe svc-content CountryService instead
 */
export class CountryConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCountryCodesPriority)" instead
	 */
	getCountryCodesPriority(): Record<string, number> {
		return this.configService.get((x) => x.core.country.countryCodesPriority, {});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getDefaultCountryCode)" instead
	 */
	getDefaultCountryCode(): string {
		return this.configService.get((x) => x.core.country.defaultCountryCode, "SE");
	}
	/**
	 * @deprecated [fabric-deprecated] - use mfe svc-content CountryService instead
	 */
	getStatesEndpoint(): string {
		return this.configService.get((x) => x.core.country.endpoints!.states, "i18n/v2/countries/:countryCode/states");
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getIgnoreCountryDetection)" instead
	 */
	getIgnoreCountryDetection() {
		return this.configService.get((x) => x.core.country.ignoreCountryDetection);
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getIgnoreAllCountriesDetection)" instead
	 */
	getIgnoreAllCountriesDetection() {
		return this.configService.get((x) => x.core.country.ignoreAllCountriesDetection);
	}
}
